import { render, staticRenderFns } from "./PasswordLost.vue?vue&type=template&id=250a726c&scoped=true&"
import script from "./PasswordLost.vue?vue&type=script&lang=js&"
export * from "./PasswordLost.vue?vue&type=script&lang=js&"
import style0 from "./PasswordLost.vue?vue&type=style&index=0&id=250a726c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250a726c",
  null
  
)

export default component.exports